<template>
  <div class="personalization-drawer">
    <!-- 设为首页 -->
    <el-drawer
      title="设为首页"
      class="order-upload"
      :visible.sync="personalizationDrawer"
      :wrapperClosable="false"
      :before-close="handleClosePersonalizationDrawer">
      <div class="el-drawer__body">
        <el-form ref="personalizationForm" :model="personalizationForm">
          <div class="tips">
            <img class="sign-blue" src="~assets/images/sigh/sigh-blue.png">
            <span class="tips-content">设置进入系统首页页面</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <el-form-item label="选择页面" prop="homePage">
            <el-cascader
              v-model="personalizationForm.homePage"
              :options="menuPageList"
              :props="personalizationProp"
              clearable
            >
            </el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleClosePersonalizationDrawer">取消</el-button>
        <el-button class="btn-blue" @click="personalizationConfirm">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Personalization from "models/page-head/personalization";
import MENU_LIST from "@/common/menu/menu.js";
import { treeFilter } from "common/js/util";
import { getUserMenu, getUserSetHomeKeyWord, saveUserSetHome, saveUserSetHomeKeyWord } from "@/common/js/storage";
export default {

  data() {
    return {
      // 个性化设置开关
      personalizationDrawer: false,
      personalizationForm: {
        // 首页keyword
        homePage: ''
      },
      personalizationProp: {
        value: 'keyword',
        label: 'name',
        children: 'children'
      },
      menuPageList: []
    }
  },

  created() {
    this.$bus.$off('parentOpenSetHomePage');
    this.$bus.on('parentOpenSetHomePage', () => {
      this.openSetHomePage()
    })
  },

  methods: {
    /** 
     * @desc 打开个性化设置
    */
    openSetHomePage() {
      this.menuPageList = getUserMenu()
      let nodeList = treeFilter(this.menuPageList, item => item.keyword === getUserSetHomeKeyWord())
      let arr = this.treeFilterKeyword(nodeList)
      this.personalizationForm.homePage = arr
      this.personalizationDrawer = true
    },

    /** 
     * @desc 获取当前页面及上级页面的keyword
    */
    treeFilterKeyword(nodeList, v = []) {
      nodeList.map(i => {
        v.push(i.keyword)
        if (i.children&&i.children.length>0) {
          this.treeFilterKeyword(i.children, v)
        }
      })
      return v
    },

    /** 
     * @desc 关闭抽屉
    */
    handleClosePersonalizationDrawer() {
      this.personalizationDrawer = false
    },

    /** 
     * @desc 确认首页
    */
    personalizationConfirm() {
      let arr = this.personalizationForm.homePage
      let homePageSetting = arr.length>0?arr[arr.length-1]:''
      let data = {
        homePageSetting
      }
      Personalization.postSetUserPersonalization(data).then(res => {
        if (res.success) {
          if (homePageSetting) {
            let obj = MENU_LIST[homePageSetting]
            saveUserSetHome(obj.url)
          } else {
            saveUserSetHome('')
          }
          saveUserSetHomeKeyWord(homePageSetting)
          this.handleClosePersonalizationDrawer()
        } else {
          this.$message.error(res.message)
        }
      });
    }
  }
}
</script>

<style lang='scss'>

</style>
